import React from 'react'
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import CardActionArea from '@mui/material/CardActionArea';
import { Link } from "react-router-dom";
import Box from "@mui/material/Box";

const VideoCard = ({vCard}) => {
  return (
    <Link to={`/videos/${vCard._id}`} className="video-tile-link">
    <Card className="video-tile">
      <CardActionArea>
        <Box sx={{ overflow: 'hidden' }}>
          <CardMedia
            sx={{
              transition: "0.5s ease all",
              "&:hover": {
                filter: "brightness(50%)",
                transform: "scale(1.2)",
              },
            }}
            component="img"
            height="140"
            image={vCard.previewImage}
            alt={vCard.title}
          />
        </Box>
        <CardContent sx={{ background: "#202020", height: "100%" }}>
          <Typography gutterBottom variant="title" fontSize={16} component="h6">
            {vCard.title}
          </Typography>
          <Typography variant="title">{vCard.releaseDate}</Typography>
        </CardContent>
      </CardActionArea>
    </Card>
    </Link>
  );
}

export default VideoCard